import React from 'react';
import Icon from '../../../components/AppIcon';

const RoleSelector = ({ selectedRole, onRoleChange }) => {
  const roles = [
    {
      value: 'influencer',
      label: 'Influencer/User',
      icon: 'Users',
      description: 'Earn cashback by sharing purchases'
    },
    {
      value: 'brand',
      label: 'Brand Partner',
      icon: 'Building2',
      description: 'Connect with influencers'
    }
  ];

  return (
    <div className="space-y-3">
      <label className="text-sm font-medium text-foreground">
        I am a
      </label>
      <div className="grid grid-cols-2 gap-2">
        {roles?.map((role) => (
          <button
            key={role?.value}
            type="button"
            onClick={() => onRoleChange(role?.value)}
            className={`p-3 rounded-xl border-2 transition-all duration-250 text-left w-full ${
              selectedRole === role?.value
                ? 'border-primary bg-primary/10' :'border-border bg-muted/50 hover:border-muted-foreground'
            }`}
          >
            <div className="flex flex-col items-start gap-2">
              <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${
                selectedRole === role?.value
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted text-muted-foreground'
              }`}>
                <Icon name={role?.icon} size={18} />
              </div>
              <div className="w-full">
                <div className="text-xs font-semibold text-foreground mb-1 leading-tight">
                  {role?.label}
                </div>
                <div className="text-xs text-muted-foreground leading-tight">
                  {role?.description}
                </div>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default RoleSelector;